import {
  getSearchLazyLoadProviderContext,
  ISearchData,
} from 'components/mainCategoriesList/providers/getSearchLazyLoadProvider';
import {IVodCollection} from 'models/vodCollections';
import {IMainCategoryVODCollectionSearch} from 'models/mainCategories';

const {
  useSearchLazyLoadProvider: useVodCollectionSearchlLazyLoadProvider,
  SearchLazyLoadProvider: VodCollectionSearchLazyLoadProvider,
} = getSearchLazyLoadProviderContext<
  IVodCollection,
  Partial<IMainCategoryVODCollectionSearch>,
  ISearchData<IVodCollection, Partial<IMainCategoryVODCollectionSearch>>
>();

export {useVodCollectionSearchlLazyLoadProvider, VodCollectionSearchLazyLoadProvider};
